import ICompileService  = angular.ICompileService;
import ILogService = angular.ILogService;

namespace app.support {
    'use strict';

    import InformacaoService = app.toolbar.InformacaoService;

    /**
     * Diretiva que permite a renderização de um componente de um serviço dentro de outro
     * @param stfComponentLoader: uma lista no formato "contexto/modulo-ts-a-ser-carregado-do-contexto"
     * O módulo ts aqui é o arquivo.ts que representa o módulo angular do contexto origem
     */
    export class StfComponentLoader implements ng.IDirective {

        constructor(
            private informacaoService: InformacaoService,
            private $compile: ICompileService,
            private $log: ILogService) {
        }

        public link($scope: any, element: ng.IAugmentedJQuery, attrs: ng.IAttributes): void {
            const dependencias: string[] = angular.fromJson(attrs["stfComponentLoader"]);

            this.informacaoService
                .carregarDependencias(dependencias)
                .then(() => element.find("stf-transclude > *:first-child").get(0))
                .catch(error => this.tryFallback(dependencias, element, error))
                .then(conteudo => this.append(conteudo, element, $scope))
                .catch(error => this.$log.error(error));

        }

        private append(conteudo: HTMLElement, element: ng.IAugmentedJQuery, $scope: any) {
            element.find("> *").remove();
            element.append(this.$compile(conteudo)($scope));
        }

        private tryFallback(dependencias: string[], element: angular.IAugmentedJQuery, error) {
            this.$log.error("Erro ao carregar as dependências: ", dependencias, error);
            return element.find("stf-transclude-fallback  > *:first-child").get(0);
        }

        public static factory(): ng.IDirectiveFactory {
            /** @ngInject */
            return (informacaoService: InformacaoService, $compile: ICompileService, $log: ILogService) => {
                return new StfComponentLoader(informacaoService, $compile, $log);
            }
        }
    }

    angular
        .module('app.support')
        .directive('stfComponentLoader', StfComponentLoader.factory());
}
